module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/7-dca5487b0dcb5f75c76d4659edc81a1c.png";